module.exports = __webpack_public_path__ + "static/asb-starship-lockup-c896bca5942666ac9e7b24818bedb7fe.png";